import { COLOR_NEUTRAL_LIGHT } from '../colors.constants';

export const colorsRadioAndCheckbox = {
  colorRadioBorder: `2px solid ${COLOR_NEUTRAL_LIGHT}`,
};
